module.exports = __webpack_public_path__ + "f47cf185924c89cc433987c532e8ef87.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/advanced_micro_devices_2021_chart.png
// module id = 1623
// module chunks = 0